import { Route, Routes } from 'react-router-dom'
import { ForgotPassword } from './components/ForgotPassword'
import { LoginWithCaptcha } from './components/LoginWithCaptcha'
import { NewPassword } from './components/NewPassword'
import { Authentication } from './components/Authentication'
import { AccountActivation } from './components/AccountActivation'
import { Page404 } from '../errors/Page404'

const AuthPage = () => {
  return (
    <>
      <Routes>
        <Route path='*' element={<Page404 />} />
        <Route path='login' element={<LoginWithCaptcha />} />
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route path='new-password' element={<NewPassword />} />
        <Route path='authentication' element={<Authentication />}></Route>
        <Route path='account-activation' element={<AccountActivation />}></Route>
      </Routes>
    </>
  )
}

export { AuthPage }
